import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "double-image": "web_ui__DoubleImage__double-image",
  "secondary": "web_ui__DoubleImage__secondary",
  "tight": "web_ui__DoubleImage__tight",
  "with-border": "web_ui__DoubleImage__with-border"
};

var DOUBLE_IMAGE_RELATIONSHIP_VALUES = ['tight'];
var DOUBLE_IMAGE_SECONDARY_BORDER_VALUES = ['default'];
/* ---------- Back-compat shims (public API) ---------- */
var DOUBLE_IMAGE_RELATIONSHIP = {
  Tight: 'tight'
};
var DOUBLE_IMAGE_SECONDARY_BORDER = {
  Default: 'default'
};
var cssClasses = classNames.bind(styles);
var DoubleImageBase = function DoubleImageBase(_ref) {
  var primary = _ref.primary,
    secondary = _ref.secondary,
    secondaryBorder = _ref.secondaryBorder,
    relationship = _ref.relationship,
    testId = _ref.testId;
  var doubleImageClass = cssClasses('double-image', relationship, _defineProperty({}, styles['with-border'], secondaryBorder === 'default'));
  return /*#__PURE__*/jsxs("div", {
    className: doubleImageClass,
    "data-testid": testId,
    children: [primary, /*#__PURE__*/jsx("div", {
      className: styles.secondary,
      children: secondary
    })]
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var DoubleImage = _Object$assign(DoubleImageBase, {
  /**
   * @deprecated Use string literals instead: 'tight'
   */
  Relationship: DOUBLE_IMAGE_RELATIONSHIP,
  /**
   * @deprecated Use string literals instead: 'default'
   */
  SecondaryBorder: DOUBLE_IMAGE_SECONDARY_BORDER
});

export { DOUBLE_IMAGE_RELATIONSHIP, DOUBLE_IMAGE_RELATIONSHIP_VALUES, DOUBLE_IMAGE_SECONDARY_BORDER, DOUBLE_IMAGE_SECONDARY_BORDER_VALUES, DoubleImage, DoubleImage as default };
//# sourceMappingURL=DoubleImage.js.map
